<mat-table #table [dataSource]="compStores">
    
    <ng-container *ngFor="let column of columnsData" [matColumnDef]="column.columnDef">
        <mat-header-cell *matHeaderCellDef [fxFlex]="column.width">
            <p class="upper mat-caption">{{column.header}}</p>
        </mat-header-cell>
        <mat-cell *matCellDef="let row" [fxFlex]="column.width" style="font-weight: 700;">
            <div>{{row[column.columnDef]}}</div>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    
    <mat-row *matRowDef="let row; columns: displayedColumns;">
    </mat-row>
</mat-table>